// extracted by mini-css-extract-plugin
module.exports = {"container":"PageErrorUi_container__11-TS","image":"PageErrorUi_image__1_ymb","content":"PageErrorUi_content__9JG1Y","msg":"PageErrorUi_msg__1Qpmo"};